module.exports = __webpack_public_path__ + "static/media/facebook-square-brands.eaf2077a.svg";